import makeStyles from '@mui/styles/makeStyles';

const styles = ({ hasErrors }: { hasErrors?: boolean }) =>
  makeStyles(theme => ({
    headerTitle: {
      color: hasErrors ? "#D92D20" : "#308CDB",
      fontFamily: "'Manrope', sans-serif",
      fontWeight: 700,
      fontSize: 18,
      lineHeight: "18px"
    },
    errorWrapper: {
      display: "flex",
      alignItems: "center",
      color: "#D92D20"
    },
    errors: {
      color: "#D92D20",
      margin: 0,
      fontSize: 14,
      fontFamily: "Manrope",
      lineHeight: "24px"
    }
  }));

export default styles;
